import { TutorCategoryType } from '@entities/tutor'

const TUTOR_PAID_CATEGORIES: string[] = [
  TutorCategoryType.PaidMath,
  TutorCategoryType.PaidEla,
]

const TUTOR_DEMO_CATEGORIES: string[] = [
  TutorCategoryType.DemoMath,
  TutorCategoryType.DemoEla,
]

export const hasTutorPaidCategories = (categories: string[]): boolean => {
  return categories.some(category => TUTOR_PAID_CATEGORIES.includes(category))
}

export const hasTutorDemoOnlyCategories = (categories: string[]): boolean => {
  return categories.some(category => TUTOR_DEMO_CATEGORIES.includes(category))
    && !hasTutorPaidCategories(categories)
}
